import React from "react"
import { Input, DatePicker, Flex, Button } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import MultiSelect from "components/common/MultiSelect"
import styles from "./index.module.css"
import CustomDrawer from "ui/Drawer"
import { useDevice } from "hooks/useDevice"
import IconWithBg from "ui/IconWithBg"
import { FilterIcon } from "icons"

const CrewFilters = ({
  search,
  onSearchChange,
  selectedRoles,
  onRoleChange,
  roleOptions,
  selectedStatuses,
  onStatusChange,
  statusOptions,
  selectedDate,
  onDateChange
}) => {
  const { t } = useTranslation()
  const { isMobile, isTablet } = useDevice()
  const [filtersDrawerOpen, setFiltersDrawerOpen] = React.useState(false)

  return (
    <div className={styles.filtersRow}>
      <Flex gap={10} className={styles.searchInput}>
        <Input
          id="search"
          type="text"
          placeholder={t("listings.tabs.resources.crew_members_placeholder") || "Search for Crew Members..."}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          // className={styles.searchInput}
          prefix={<SearchOutlined aria-hidden="true" />}
          allowClear
          aria-label={t("clients.search_clients") || "Search"}
        />
        {isMobile && (
          <IconWithBg
            className={styles.crewButton}
            height={40}
            width={40}
            icon={<FilterIcon color="currentColor" className={styles.crewFilterButton} />}
            onClick={() => setFiltersDrawerOpen(!filtersDrawerOpen)}
          />
        )}
      </Flex>

      <MultiSelect
        value={selectedRoles}
        onChange={onRoleChange}
        options={roleOptions}
        placeholder={selectedRoles.length > 0 ? t("Roles") : "All Roles"}
        dropdownClassName={styles.dropdownButton}
        t={t}
      />
      <MultiSelect
        value={selectedStatuses}
        onChange={onStatusChange}
        options={statusOptions}
        placeholder={selectedStatuses.length > 0 ? t("Statuses") : "All Statuses"}
        dropdownClassName={styles.dropdownButton}
      />
      <div className={styles.datePickerWrapper}>
        <DatePicker
          placeholder="Select Date"
          value={selectedDate}
          onChange={(date) => onDateChange(date)}
          picker="day"
          format="MM/DD/YYYY"
          className={styles.datePickerInput}
          allowClear
          prefix="Available on"
        />
      </div>

      {isMobile && (
        <CustomDrawer title="Filters" open={filtersDrawerOpen} setOpen={() => setFiltersDrawerOpen(!filtersDrawerOpen)}>
          <Flex vertical gap={10} align="start">
            <MultiSelect
              style={{ minWidth: "100%", maxWidth: "100%" }}
              value={selectedRoles}
              onChange={onRoleChange}
              options={roleOptions}
              placeholder={selectedRoles.length > 0 ? t("Roles") : "All Roles"}
              dropdownClassName={styles.dropdownMobileButton}
              t={t}
            />
            <MultiSelect
              style={{ minWidth: "100%", maxWidth: "100%" }}
              value={selectedStatuses}
              onChange={onStatusChange}
              options={statusOptions}
              placeholder={selectedStatuses.length > 0 ? t("Statuses") : "All Statuses"}
              dropdownClassName={styles.dropdownMobileButton}
            />
            <div className={styles.datePickerMobileWrapper}>
              <DatePicker
                placeholder="Select Date"
                value={selectedDate}
                onChange={(date) => onDateChange(date)}
                picker="day"
                format="MM/DD/YYYY"
                className={styles.datePickerInput}
                allowClear
                prefix="Available on"
              />
            </div>

          </Flex>
        </CustomDrawer>
      )}
    </div>
  )
}

CrewFilters.propTypes = {
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  selectedRoles: PropTypes.array.isRequired,
  onRoleChange: PropTypes.func.isRequired,
  roleOptions: PropTypes.array.isRequired,
  selectedStatuses: PropTypes.array.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  statusOptions: PropTypes.array.isRequired,
  selectedDate: PropTypes.object,
  onDateChange: PropTypes.func.isRequired
}

export default React.memo(CrewFilters)
